interface Props {
    width?: number;
    height?: number;
}
export function Spacer({ width = 8, height = 8 }: Props) {
    return <div style={{ width, height }} />;
}
